import React from 'react';
import SessionLayout from '../layouts/Session/Session';
import {setPageTitle} from '../utils/helpers';
import TroubleLoggingIn from "../components/Session/TroubleLoggingIn";

const TroubleLoggingInPageContainer = () => {
  setPageTitle('Forgot Password | Access your UK savings accounts');

  return (
    <SessionLayout>
      <TroubleLoggingIn />
    </SessionLayout>
  );

};

export default TroubleLoggingInPageContainer;
